import { useLoggerEvents } from '@shared-ui/logger-context';
import { getCookie } from '@utils/common-utils';
import { LOG_EVENT_TYPES, LOG_EVENTS } from 'src/constants';

import { useStores } from './use-stores';

const useCommonLogger = () => {
  const { user } = useStores();
  const events = useLoggerEvents(LOG_EVENTS);

  const duaid = getCookie('DUAID');
  const quantumSessionId = getCookie('QuantumMetricSessionID');

  const commonFields = {
    user: user?.userId,
    partnerAccountId: user?.partnerAccountId,
    duaid,
    quantumSessionId,
  };

  const logEvent = (eventType: LOG_EVENT_TYPES, payload) => {
    const logBody = {
      ...commonFields,
      ...payload,
    };

    const event = events[LOG_EVENT_TYPES[eventType]];

    event.log(JSON.stringify(logBody));
  };

  return {
    logEvent,
  };
};

export { useCommonLogger };
